/**
 * Given a URLSearchParams instance and a list of {@link URLParamFilterInput} objects, get the value
 * of each paramInput and return it as a complete {@link URLParamFilter}.
 * @param searchParams an instance of URLSearchParams, usually created by using `useLocation` from
 * react-router-dom, like so:
 * ```JavaScript
 * const location = useLocation();
 * const searchParams = new URLSearchParams(location.search);
 * ```
 * @param paramInputs an array of {@link URLParamFilterInput} objects that dictate which URL
 * parameters to read and map to the return value as {@link URLParamFilter} objects
 * @returns - an array of {@link URLParamFilter} objects
 */
export const mapSearchParamsToFilters = (
    searchParams: URLSearchParams,
    paramInputs: URLParamFilterInput[],
): URLParamFilter[] =>
    paramInputs.map((paramInput: URLParamFilterInput): URLParamFilter => {
        const rawValue = searchParams.get(paramInput.paramKey);

        const decodedValue = rawValue ? decodeURIComponent(rawValue) : null;

        if (paramInput.filterValueType !== 'number') {
            return {
                ...paramInput,
                paramValue: decodedValue,
            };
        }

        return {
            ...paramInput,
            paramValue:
                decodedValue !== null ? parseInt(decodedValue, 10) : null,
        };
    });
